// touch: 2026-05-03-gallery-change-event
// PDP custom event tracking.
// Pushes events to BOTH window.dataLayer (for future GTM consumption) and
// window.gtag (which routes through the existing GT-TBBPS4P Google Tag to
// the connected GA4 property G-WEF1VPT6MZ). Safe if either is missing.
//
// Toggle off via: section setting "Enable PDP custom event tracking" in
// Shopify Admin (Product section). When unchecked this file is not loaded.
(function () {
  'use strict';

  // Read product/variant context emitted by the Liquid section as JSON.
  // One read at startup; reused for every event so payloads stay consistent.
  var ctx = (function () {
    var el = document.getElementById('tc-pdp-context');
    if (!el) return {};
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return {}; }
  })();

  function fire(eventName, meta) {
    // Flatten ctx (product_id, handle, etc.) into the gtag params for GA4
    // event-scoped fields. dataLayer keeps the structured nesting.
    var payload = {};
    for (var k in ctx) if (Object.prototype.hasOwnProperty.call(ctx, k)) payload[k] = ctx[k];
    if (meta) for (var m in meta) if (Object.prototype.hasOwnProperty.call(meta, m)) payload[m] = meta[m];

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, pdp: ctx, meta: meta || {} });

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    }
  }

  // Helper: which thumb (by data-index) is currently active.
  function activeThumbIndex() {
    var t = document.querySelector('[data-thumb].is-active');
    if (!t) return null;
    var i = parseInt(t.getAttribute('data-index'), 10);
    return isNaN(i) ? null : i;
  }

  // ---- Click-driven events ----
  document.addEventListener('click', function (e) {
    var t = e.target;
    var hit;

    // Read Reviews link (inline link + mobile trio reviews cell)
    if ((hit = t.closest('a[href="#shopify-product-reviews"], a.tc-info__trio-cell--reviews'))) {
      fire('pdp_review_link_click', {
        source: hit.classList.contains('tc-info__trio-cell--reviews') ? 'trio' : 'inline'
      });
      return;
    }

    // Gallery navigation (next/prev/thumb/dot/swipe/keyboard) is handled
    // via the unified `tc:gallery-change` event below — see the listener
    // further down. Clicks on [data-next]/[data-prev]/[data-thumb]/
    // [data-dot] therefore fall through here intentionally (the gallery
    // dispatches the event after committing state).

    // Zoom button + zoom anchor (PhotoSwipe lightbox open)
    if (t.closest('[data-zoom-btn], .tc-gal__zoom-link')) {
      fire('pdp_gallery_zoom_open', { index: activeThumbIndex() });
      return;
    }

    // Sticky-buy Add to cart button (mobile)
    if (t.closest('[data-sticky-add]')) {
      var qInput = document.querySelector('[data-sticky-qty]');
      var qty = qInput ? parseInt(qInput.value, 10) : 1;
      fire('pdp_sticky_atc_click', { qty: isNaN(qty) ? 1 : qty });
      return;
    }

    // Discount claim button ("Add to Cart & Apply 15% Off")
    if (t.closest('[data-claim-btn]')) {
      fire('pdp_discount_claim_click', {});
      return;
    }
  }, { passive: true, capture: true });

  // ---- Accordion toggle ----
  // The HTML <details> toggle event doesn't bubble, so attach per-element.
  var ACC_PANELS = {
    'tc-acc-panel-1': 'full_description',
    'tc-acc-panel-2': 'specs_dimensions',
    'tc-acc-panel-3': 'shipping_returns',
    'tc-acc-panel-4': 'condition_labels',
    'tc-acc-panel-5': 'faqs',
    'tc-acc-panel-6': 'about_brand'
  };
  Array.prototype.forEach.call(
    document.querySelectorAll('details[id^="tc-acc-panel-"]'),
    function (d) {
      d.addEventListener('toggle', function () {
        var panel = ACC_PANELS[d.id] || d.id;
        fire(d.open ? 'pdp_accordion_open' : 'pdp_accordion_close', { panel: panel });
      });
    }
  );

  // ---- Gallery change (unified) ----
  // tc-pdp.js dispatches `tc:gallery-change` with { from, to, source, direction }
  // on every active-media change (button click, thumb tap, dot tap, swipe,
  // keyboard arrow). We translate to the existing event names so GA4 reports
  // and registered custom dimensions keep working unchanged.
  document.addEventListener('tc:gallery-change', function (e) {
    var d = (e && e.detail) || {};
    var to = typeof d.to === 'number' ? d.to : null;
    var src = d.source || 'unknown';
    var dir = typeof d.direction === 'number' ? d.direction : 0;

    if (src === 'thumb' || src === 'dot') {
      // Both thumb taps and dot taps are explicit "jump to N" gestures —
      // route to pdp_gallery_thumb so the existing report keeps a single
      // home for all jump-style navigation. `source` differentiates them.
      fire('pdp_gallery_thumb', { index: to, source: src });
      return;
    }
    // Sequential nav: button, swipe, keyboard. Direction sign decides next/prev.
    if (dir > 0) {
      fire('pdp_gallery_next', { index: to, source: src });
    } else if (dir < 0) {
      fire('pdp_gallery_prev', { index: to, source: src });
    }
  });

  // ---- Discount email submit success ----
  // Custom event dispatched from tc-pdp.js after Klaviyo returns 2xx so we
  // avoid tightly coupling tracking with the form-submit code path.
  // PII guard: only the email domain is forwarded, never the full address.
  document.addEventListener('tc:discount-submit-success', function (e) {
    var domain = (e.detail && e.detail.email_domain) || '';
    fire('pdp_discount_email_submit', { email_domain: domain });
  });
})();
